import { IUserTypes } from "../../../types/user.types";

export const userTypes: IUserTypes = {
  USER: '',
  STUDENT: 'student',
  INSTRUCTOR: 'instructor'
}
